<ng-container *ngIf="selectedSvpChildSurvey">
  <ng-container
    *ngIf="showMultipleLabel; then multiple; else single"
  ></ng-container>

  <ng-template #multiple>
    <span class="grey-text">
      ({{ selectedSvpChildSurvey.survey_localization }}) -
    </span>
    <span>
      {{ selectedSvpChildSurvey.survey_grouping }}
    </span>

    <div class="setting-info mx-0">
      <i>
        <button psUiButton>Multiple</button>
      </i>
      <p class="multi-list-container">
        <span>
          <ul class="multi-item-list">
            <li *ngFor="let survey of mcSvpChildSurveys">
              <span class="grey-text">
                ({{ survey.survey_localization }}) -
              </span>
              <span>
                {{ survey[this.field] }}
              </span>
            </li>
          </ul>
        </span>
      </p>
    </div>
  </ng-template>

  <ng-template #single>
    {{ selectedSvpChildSurvey.survey_grouping }}
  </ng-template>
</ng-container>
